import { Role } from '@/router/_helper';

const contact = {
  path: '/account-closing/:id?',
  name: 'accountClosing',
  component: () =>
    import(
      /* webpackChunkName: "accountClosing" */ '@/components/closing/ClosingTools.vue'
    ),
  meta: { authorize: [Role.CloseAccount], requiresAuth: true },
};

export default contact;
